import { userDuckCreator } from 'axl-ducks';

const userDuck = userDuckCreator();

export default userDuck;
